module.exports = __webpack_public_path__ + "static/media/21ECLAC7.57903c06.jpg";